// src/utils/api.js
import axios from "axios";
import { message } from "antd"; // optional for toast messages
import QueryString from "qs";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL || "https://api.quelld.webdezign.uk/api",
  paramsSerializer: (params) =>
    QueryString.stringify(params, { arrayFormat: "brackets" }), // 👈 key line
  headers: {
    "Content-Type": "application/json",
  },
});

// --- Request interceptor ---
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// --- Response interceptor ---
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const messageText =
      error.response?.data?.message || error.message || "Error occurred";

    if (
      status === 401 ||
      messageText.toLowerCase().includes("unauthenticated")
    ) {
      // Handle logout or account deletion
      localStorage.removeItem("authToken");
      localStorage.removeItem("authData");
      message.warning(
        "Your account has been deactivated. Please contact support or log in again."
      );
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default api;
